/* 07-02-2025 Zoom feature on PDP */
function enableZoom(zoomType) {
  if ($(window).width() > 768) {
    document.querySelectorAll(".image-slide-item").forEach((item) => {
      const img = item.querySelector(".zoomable");
      const zoomedImage = item.querySelector(".zoomed-image");
      const zoomUrl = img.getAttribute("data-zoom");

      // Ensure background image is set immediately
      zoomedImage.style.backgroundImage = `url(${zoomUrl})`;

      function updateZoomPosition(event) {
        const rect = item.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;
        zoomedImage.style.backgroundPosition = `${x}% ${y}%`;
      }

      if (zoomType === "hover") {
        item.addEventListener("mouseenter", function (event) {
          zoomedImage.style.display = "block";
          zoomedImage.style.opacity = "1";
          updateZoomPosition(event);
        });

        item.addEventListener("mousemove", function (event) {
          item.classList.remove("zoom-active");
          updateZoomPosition(event);
        });

        item.addEventListener("mouseleave", function () {
          zoomedImage.style.opacity = "0";
          setTimeout(() => {
            zoomedImage.style.display = "none";
          }, 300);
        });
      } else if (zoomType === "click") {
        let isZoomed = false;

        item.addEventListener("click", function (event) {
          item.classList.add("zoom-active");
          const rect = item.getBoundingClientRect();
          const x = ((event.clientX - rect.left) / rect.width) * 100;
          const y = ((event.clientY - rect.top) / rect.height) * 100;

          if (!isZoomed) {
            zoomedImage.style.display = "block";
            zoomedImage.style.opacity = "1";
            zoomedImage.style.backgroundPosition = `${x}% ${y}%`;
            isZoomed = true;
          } else {
            item.classList.remove("zoom-active");
            zoomedImage.style.opacity = "0";
            setTimeout(() => {
              zoomedImage.style.display = "none";
            }, 300);
            isZoomed = false;
          }
        });

        item.addEventListener("mousemove", function (event) {
          if (isZoomed) {
            updateZoomPosition(event);
          }
        });

        item.addEventListener("mouseleave", function () {
          if (isZoomed) {
            item.classList.remove("zoom-active");
            zoomedImage.style.opacity = "0";
            setTimeout(() => {
              zoomedImage.style.display = "none";
            }, 300);
            isZoomed = false;
          }
        });
      }
    });
  }
}

function preloadZoomImages() {
  document.querySelectorAll(".zoomable").forEach((img) => {
    const zoomUrl = img.getAttribute("data-zoom");
    if (zoomUrl) {
      const preloadImg = new Image();
      preloadImg.src = zoomUrl;
    }
  });
}

// Preload zoom images when the page loads
window.addEventListener("load", preloadZoomImages);

$(document).ready(function () {
  document.addEventListener("slickSlidesFiltered", function (event) {
    if (!$("#main-image-slider-source").hasClass("stackImage-false")) {
      console.log("Slick slides have been filtered!", event);
      enableZoom("hover");
    } else {
      enableZoom("click");
    }
  });

  if (!$("#main-image-slider-source").hasClass("stackImage-false")) {
    enableZoom("hover");
  } else {
    enableZoom("click");
  }
});
/* 07-02-2025 Zoom feature on PDP ends */
